<template>
    <h2 class="text-lg font-medium">
        <slot></slot>
    </h2>
</template>
